import React from "react";
import { observer } from "mobx-react";
import { PageLayout } from "../../../../common/layout";
import { useRootStore } from "../../../../store/contexts";
import { ReportView } from "./ReportView";
import { ReportViewStore } from "../../store/ReportViewStore";
import { useStore } from "../../../../hooks";

export const ReportViewPage = observer(() => {
  const rootStore = useRootStore();
  const { router } = rootStore;

  const id = router.params?.id as string;
  const path = `/report/view/${id}`;

  const store = useStore(
    path,
    () => {
      const s = new ReportViewStore(rootStore);
      return s;
    },
    { id }
  );

  return (
    <div>
      <PageLayout
        navigationElements={{
          links: [],
          onNavigatedTo: (id) => {
            store.setCardState(id, true);
          },
        }}
      >
        <ReportView reportViewStore={store} />
      </PageLayout>
    </div>
  );
});
